import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ApplicationConfigService } from './application-config.service';
import { getOfferHandlingTypeIdentifier, IOfferHandlingType } from '../models/offer-handling-type.model';
import { Observable } from 'rxjs';
import { createRequestOption, mapAsBody } from '../app/shared/util/request-util';
import { isPresent } from './operators';
import { EntityArrayResponseType, EntityResponseType, OfferHandlingTypeService } from './offer-handling-type.service';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { ApiProviderService } from './api-provider.service';
import { HandlingTypeViewModel } from '../models/handling-type-view.model';
import { map } from 'rxjs/operators';
import { HandlingType } from '../models/handling-type.model';

@Injectable({ providedIn: 'root' })
export class OfferHandlingTypeExtendedService extends OfferHandlingTypeService {
  protected override resourceUrl = API_ENDPOINTS.OFFER_HANDLING_TYPE;

  constructor(private apiProvider: ApiProviderService, http: HttpClient, applicationConfigService: ApplicationConfigService) {
    super(http, applicationConfigService);
  }

  override create(offerHandlingType: IOfferHandlingType): Observable<EntityResponseType> {
    return this.apiProvider.post<IOfferHandlingType>(this.resourceUrl, offerHandlingType, { observe: 'response' });
  }

  override update(offerHandlingType: IOfferHandlingType): Observable<EntityResponseType> {
    return this.apiProvider.put<IOfferHandlingType>(`${this.resourceUrl}/${getOfferHandlingTypeIdentifier(offerHandlingType)}`, offerHandlingType);
  }

  override partialUpdate(offerHandlingType: IOfferHandlingType): Observable<EntityResponseType> {
    return this.apiProvider.patch<IOfferHandlingType>(`${this.resourceUrl}/${getOfferHandlingTypeIdentifier(offerHandlingType)}`, offerHandlingType);
  }

  override find(id: number): Observable<EntityResponseType> {
    return this.apiProvider.get<IOfferHandlingType>(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  override query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.apiProvider.get<IOfferHandlingType[]>(this.resourceUrl, { params: options, observe: 'response' });
  }

  override delete(id: number): Observable<HttpResponse<{}>> {
    return this.apiProvider.delete(`${this.resourceUrl}/${id}`);
  }

  public getCurrent(): Observable<HandlingTypeViewModel[]> {
    return this.apiProvider
      .publicGet<HandlingTypeViewModel[]>(this.resourceUrl, { observe: 'response' })
      .pipe(mapAsBody)
      .pipe(map(list => (list || []).map(val => new HandlingTypeViewModel(val))));
  }

  getByOfferId(offerId: number): Observable<EntityArrayResponseType> {
    return this.apiProvider.get<IOfferHandlingType[]>(this.resourceUrl + '/offer/' + offerId);
  }

  override addOfferHandlingTypeToCollectionIfMissing(
    offerHandlingTypeCollection: IOfferHandlingType[],
    ...offerHandlingTypesToCheck: (IOfferHandlingType | null | undefined)[]
  ): IOfferHandlingType[] {
    const offerHandlingTypes: IOfferHandlingType[] = offerHandlingTypesToCheck.filter(isPresent);
    if (offerHandlingTypes.length > 0) {
      const offerHandlingTypeCollectionIdentifiers = offerHandlingTypeCollection.map(offerHandlingTypeItem => getOfferHandlingTypeIdentifier(offerHandlingTypeItem));
      const offerHandlingTypesToAdd = offerHandlingTypes.filter(offerHandlingTypeItem => {
        const offerHandlingTypeIdentifier = getOfferHandlingTypeIdentifier(offerHandlingTypeItem);
        if (offerHandlingTypeIdentifier == null || offerHandlingTypeCollectionIdentifiers.includes(offerHandlingTypeIdentifier)) {
          return false;
        }
        offerHandlingTypeCollectionIdentifiers.push(offerHandlingTypeIdentifier);
        return true;
      });
      return [...offerHandlingTypesToAdd, ...offerHandlingTypeCollection];
    }
    return offerHandlingTypeCollection;
  }
}
